import { ComponentCO2Link } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';
import CO2Model from './co2-model';

export default class FilterComponentCO2LinkModel {
	public set filter(value: string) {
		this.#co2Collection.filter = value.toLowerCase();
	}

	public get filter(): string {
		return this.#co2Collection.filter;
	}

	// If we don't have data yet, disable the filter input.
	public filterInputEnabled: boolean;
	// If we need to reset the filter input between reloads,
	// we can use this property that is bound to the input text.
	public filterInputText: string;
	#co2Collection: ObservableCollection<ComponentCO2Link>;
	public constructor(CO2Model: CO2Model) {
		this.filterInputEnabled = false;
		this.filterInputText = '';
		this.#co2Collection = CO2Model.listComponentCO2LinkModel.co2LinkCollection;
		this.#co2Collection.filterProperties = ['description', 'name'];
	}
}
